import produce from 'immer';
import _ from 'underscore';

import { createReducer, getErrorStatus, getInitialStatus, getPendingStatus } from '../utils';
import type { Comment } from '../../../shared/model-typings';
import type { AsyncStatus } from '../../types';

import type { CommentWithUser } from './actions';

export type CommentStoreState = {
  comments: Record<string, Comment[]>,
  status: AsyncStatus;
};

const initialState: CommentStoreState = {
  comments: {},
  status: getInitialStatus(),
};

const reducer = createReducer(initialState, {
  // fetch actions
  [`FETCH_COMMENTS_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },
  [`FETCH_COMMENTS_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },
  [`FETCH_COMMENTS_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      const comments = action.payload.data.map((comment: CommentWithUser) => {
        const populatedComment = comment;
        return populatedComment;
      });
      draftState.comments[action.payload.projectId] = comments;
    });
  },
  // create actions
  [`CREATE_COMMENTS_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },
  [`CREATE_COMMENTS_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      draftState.comments[action.payload.projectId] = [action.payload.data, ...draftState.comments[action.payload.projectId]];
    });
  },
  [`CREATE_COMMENTS_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },

  // update actions
  [`UPDATE_COMMENTS_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },
  [`UPDATE_COMMENTS_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      const updateIndex = _.findIndex(state.comments[action.payload.projectId], comment => comment.id === action.payload.data.id);
      if (updateIndex > -1) {
        draftState.comments[action.payload.projectId][updateIndex] = action.payload.data;
      }
    });
  },
  [`UPDATE_COMMENTS_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },

  // delete actions
  [`DELETE_COMMENTS_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },
  [`DELETE_COMMENTS_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      const deleteIndex = _.findIndex(state.comments[action.payload.projectId], comment => comment.id === action.payload.id);
      if (deleteIndex > -1) {
        draftState.comments[action.payload.projectId].splice(deleteIndex, 1);
      }
    });
  },
  [`DELETE_COMMENTS_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },
});

export default reducer;
